
    import './styles.scoped.css';
    export default {
  "content-enter": "awsui_content-enter_gwq0h_13ru4_103",
  "awsui-motion-fade-in": "awsui_awsui-motion-fade-in_gwq0h_13ru4_1",
  "trigger-expanded": "awsui_trigger-expanded_gwq0h_13ru4_125",
  "icon": "awsui_icon_gwq0h_13ru4_139",
  "root": "awsui_root_gwq0h_13ru4_157",
  "expand-button": "awsui_expand-button_gwq0h_13ru4_195",
  "expanded": "awsui_expanded_gwq0h_13ru4_202",
  "icon-container": "awsui_icon-container_gwq0h_13ru4_206",
  "icon-container-container": "awsui_icon-container-container_gwq0h_13ru4_210",
  "wrapper": "awsui_wrapper_gwq0h_13ru4_214",
  "wrapper-default": "awsui_wrapper-default_gwq0h_13ru4_222",
  "wrapper-footer": "awsui_wrapper-footer_gwq0h_13ru4_222",
  "wrapper-navigation": "awsui_wrapper-navigation_gwq0h_13ru4_226",
  "wrapper-container": "awsui_wrapper-container_gwq0h_13ru4_229",
  "wrapper-compact": "awsui_wrapper-compact_gwq0h_13ru4_233",
  "header-deprecated": "awsui_header-deprecated_gwq0h_13ru4_246",
  "wrapper-expanded": "awsui_wrapper-expanded_gwq0h_13ru4_268",
  "header": "awsui_header_gwq0h_13ru4_246",
  "header-wrapper": "awsui_header-wrapper_gwq0h_13ru4_288",
  "header-actions-wrapper": "awsui_header-actions-wrapper_gwq0h_13ru4_300",
  "header-button": "awsui_header-button_gwq0h_13ru4_305",
  "header-container-button": "awsui_header-container-button_gwq0h_13ru4_305",
  "header-container": "awsui_header-container_gwq0h_13ru4_305",
  "header-navigation": "awsui_header-navigation_gwq0h_13ru4_340",
  "header-text": "awsui_header-text_gwq0h_13ru4_377",
  "content": "awsui_content_gwq0h_13ru4_103",
  "content-default": "awsui_content-default_gwq0h_13ru4_384",
  "content-footer": "awsui_content-footer_gwq0h_13ru4_388",
  "content-expanded": "awsui_content-expanded_gwq0h_13ru4_392",
  "content-compact": "awsui_content-compact_gwq0h_13ru4_395",
  "focusable": "awsui_focusable_gwq0h_13ru4_399",
  "click-target": "awsui_click-target_gwq0h_13ru4_414"
};
  